import Splide from '@splidejs/splide'

export default function Sliders() {

	// --- Case Study Feed Slider ---
	const caseStudyElements = document.querySelector('.js-case-study-slider')
	if (caseStudyElements) {
		let slider = new Splide('.js-case-study-slider', {
			type: 'loop',
			arrows: false,
			pagination: true,
			keyboard: false,
			gap: 40,
			drag: true,
			rewind: true,
			autoplay: true,
			speed: 1000,
			interval: 5000,
			pauseOnHover: false,
			snap: true,
			autoHeight: true,
			classes: {
				pagination: 'splide__pagination o-list-bare e-dots',
				page: 'splide__pagination__page o-list-bare__item e-dots__item',
			},
		}).mount();
		if (slider.length == 1) {
			slider.options.type = 'slide'	
		}
	}

	const gallery = document.querySelector('.js-product-gallery-main')
	if (gallery) {
		let main = new Splide('.js-product-gallery-main', {
			type: 'fade',
			perPage: 1,
			perMove: 1,
			pagination: false,
			arrows: true,
			mediaQuery: 'min',
			speed: 300
		})

		let thumbnails = new Splide('.js-product-gallery-thumb', {
			type: 'slide',
			rewind: true,
			isNavigation: true,
			perPage: 4,
			arrows: false,
			pagination: false,
			gap: 20,
		});

		main.sync( thumbnails ).mount();
		thumbnails.sync( main ).mount();
	}

}
